import Indicador from "..";
import EnlDespEditFields from "./components/EnlDespEditFields";
import { EnlDespParamFields } from "./components/EnlDespParamFields";
import enlDespReport from "./reports";
import enlDespReportSummary from "./reports/summary";

export default class EnlDesp extends Indicador {
    static get fullName() {
        return "Enleiramento/Desenleiramento de palha";
    }

    static get abbrev() {
        return "Enl./Des.";
    }

    static get field() {
        return "enldesp";
    }

    static paramFields(tipoIndicadorField = '') {
        return <EnlDespParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EnlDespEditFields visita={visita} TipoClass={TipoClass} />;
    }

    async renderReport(visita) {
        return enlDespReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return enlDespReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }
        const totalAvaliados = apontamento.coletas.reduce((s, c) => s + parseFloat(c.metrosAvaliados || 0), 0);
        const totalPalha     = apontamento.coletas.reduce((s, c) => s + parseFloat(c.metrosSemPalha  || 0), 0);
        if (!totalAvaliados) return 0;
        return Math.min((totalPalha / totalAvaliados) * 100, 100).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 89.47, 100, 103.15);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        return [];
    }

    static getResultStr(apontamento) {
        if (!apontamento.coletas) return "";
        const totalAvaliados = apontamento.coletas.reduce((s, c) => s + parseFloat(c.metrosAvaliados || 0), 0);
        const totalPalha     = apontamento.coletas.reduce((s, c) => s + parseFloat(c.metrosSemPalha  || 0), 0);
        return `S/ palha: ${totalPalha} de ${totalAvaliados} metros`;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            { title: "Talhão", field: "talhao.nome" },
            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },
            {
                title: "Palha (%)", field: "conformidade", width: 38,
                getColor: a => IndicadorClass.getColorStatus(
                    IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta)
                )
            },
        ];
    }
}
